export const getManualCompletionUrl = (nextStepUrl: string) => {
  // The backend validation of manual_completion_url domain is either *.dash.ai
  // or *.dropbox.com as defined by this implementation at the time of writing:
  // https://github.com/dropbox-internal/server/blob/b4524ae9134deeb9b7d294bd172e8034f5aa215f/atlas/janus_oauth/lib/oauth_initiate.py#L18-L32
  // Ideally we'd have some more flexibility to use a testing url like
  // localhost:3000, but for now we'll use the dash.ai url.
  return `https://dash.ai/setup/admin-self-serve/${nextStepUrl}`;
};
